function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 31.86C0 10.709 15.96-1.891 33.544 1.484 58.446 6.264 60 17.672 60 34.27s-6.413 24.564-28.703 26.543C13.15 62.424 0 48.458 0 31.86z",
  fill: "#8781bd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.677 30.919h-2.543v10.02h-3.876V30.92h-1.857v-3.537h1.857v-2.274c0-1.6.727-4.168 3.876-4.168H34v3.41h-2.1c-.322 0-.807.169-.807.969v2.063H34z",
  fill: "#fff"
});

function SvgFacebookWBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 61,
    width: 60
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYxIiB2aWV3Qm94PSIwIDAgNjAgNjEiIHdpZHRoPSI2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMCAzMS44NTk5YzAtMjEuMTUxNCAxNS45NjAzLTMzLjc1MTEgMzMuNTQzOS0zMC4zNzYwOSAyNC45MDE4IDQuNzc5NjUgMjYuNDU2MSAxNi4xODc2OSAyNi40NTYxIDMyLjc4NTg5cy02LjQxMzIgMjQuNTY0NS0yOC43MDMxIDI2LjU0MzRjLTE4LjE0NTcgMS42MTExLTMxLjI5NjktMTIuMzU1LTMxLjI5NjktMjguOTUzMnoiIGZpbGw9IiM4NzgxYmQiLz48cGF0aCBkPSJtMzMuNjc3MSAzMC45MTg5aC0yLjU0MzR2MTAuMDIxaC0zLjg3NTd2LTEwLjAyMWgtMS44NTcxdi0zLjUzNjloMS44NTcxdi0yLjI3MzZjMC0xLjYuNzI2Ny00LjE2ODUgMy44NzU3LTQuMTY4NWgyLjg2NjN2My40MTA2aC0yLjA5OTNjLS4zMjMgMC0uODA3NC4xNjg0LS44MDc0Ljk2ODR2Mi4wNjMxaDIuOTA2N3oiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
export { SvgFacebookWBg as ReactComponent };